import { useIntl } from 'react-intl';

export const ADVERTISER_COLUMN_VISIBILITY_KEY = 'advertiserList';

// Assumed (ticket does not define it): every column except name, leading and actions can be hidden.
export const ADVERTISER_HIDEABLE_COLUMN_IDS = ['agency', 'mediaGroup', 'campaignActive', 'creationDate', 'budgetSpend'];

/** Labels of the hideable columns plus the name entry shown (always checked) in the column visibility menu. */
export function useAdvertiserColumnLabels(): Record<string, string> {
  const { formatMessage } = useIntl();

  return {
    agency: formatMessage({ defaultMessage: 'Agency', id: 'advertisers.list.toolbar.agency' }),
    budgetSpend: formatMessage({ defaultMessage: 'Budget Spent', id: 'advertisers.list.toolbar.budget' }),
    campaignActive: formatMessage({ defaultMessage: 'Active Campaign Plans', id: 'advertisers.list.toolbar.active' }),
    creationDate: formatMessage({ defaultMessage: 'Creation Date', id: 'advertisers.list.toolbar.creation' }),
    mediaGroup: formatMessage({ defaultMessage: 'Media Group', id: 'advertisers.list.toolbar.mediaGroup' }),
    name: formatMessage({ defaultMessage: 'Advertiser name', id: 'advertisers.list.columnVisibility.name' })
  };
}
